import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const reqUrl = `${BASE_URL}/chatbot/postback`;

export const sendLinePostback = async (payload) => {
  try {
    const response = await axios.post(reqUrl, payload);

    return response.data;
  } catch (err) {
    throw err;
  }
};

const calendarCenterUrl = `${BASE_URL}/calendar/postback`;
export const getCalendarPostback = async (payload) => {
  try {
    const response = await axios.post(calendarCenterUrl, payload, {
      responseType: 'blob',
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};

const lineReurlTagUrl = `${BASE_URL}/hotai_tag/reurl`;
export const sendLineReurlTag = async (payload, idToken) => {
  try {
    const response = await axios.post(lineReurlTagUrl, payload, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};
